import React, { useEffect } from 'react';
import CenterPanel from './centerPanel';
import Modal from '../../../shared/modal/content';
import { updateShowQuickViewModal, updateHideWhenClickAwayQuickView } from '../../../../actions/modal';
import { Container, Icon } from 'semantic-ui-react';
import HelpMenuDropdown from '../../../shared/menu-options/helpMenu';
import UserMenuDropdown from '../../../shared/menu-options/userMenu';
import { Media } from '../../../../mediaSetting';

const ViewQuickView = (props) => {
  useEffect(() => {
    if (props.renderOnMount) {
      let show = true;
      let hideWhenClickAway = true;
      props.dispatch(updateHideWhenClickAwayQuickView(hideWhenClickAway));
      props.dispatch(updateShowQuickViewModal(show));
    }
    return () => {
      componentCleanup();
    };
  }, []);

  const componentCleanup = () => {
    console.log('clearing model popup with unload'); //fixing https://jira.attendanywhere.com/browse/VCM-1755
    props.dispatch(updateShowQuickViewModal(false));
  };

  const calculateMenuHeight = () => {
    // To use different height for the last item based on the bottom space
    if (!!props.canAccessResourceCentre) {
      if (!!props.canSeeEntityAdminPage || !!props.userHasReports) {
        return 'large-menu-height';
      } else {
        return 'medium-menu-height';
      }
    } else if (!!props.canSeeEntityAdminPage || !!props.userHasReports) {
      return 'medium-menu-height';
    } else {
      return 'small-menu-height';
    }
  };
  const openQuickViewHelp = () => {
    window.open(APP.EXTERNAL_LINKS.ViewQuickView.Help, 'mgt-console-help');
  };

  const generateHeaderMarkup = (mobileOrNot, aboutMenuHeightClass) => {
    return (
      <div className="header color-white bg-transparent">
        <Icon name="home" size="large" className="mrrs" style={{ marginTop: '-4px' }} />
        {APP.LANGUAGE.QuickView.QuickViewTitle}
        <div className="fr">
          <HelpMenuDropdown
            helpMenuClassName="mrrs"
            itemClass=""
            subMenuItemParentClass=""
            subMenuClass="left menu sub-menu-items quick-view-help-subMenu"
            user={props.user}
            normalSemanticUI="true"
            id={mobileOrNot ? 'quick-view-help-menu-mobile' : 'quick-view-help-menu'}
            HelpWithThisPageOnClick={openQuickViewHelp}
            subMenuHeightForAboutTab={`${aboutMenuHeightClass} about-sub-menu-items`}
            dispatch={props.dispatch}
          />
          <UserMenuDropdown
            user={props.user}
            itemClass="menu-items-left-aligned no-sub-menu"
            subMenuItemParentClass=""
            subMenuClass="left menu sub-menu-items quick-view-help-subMenu admin-sub-menu-items"
            userAvatarClass="fl"
            userAvatarTextRatio={2.3}
            userAvatarSize={35}
            userMenuClassName="top user-item item none-user-select"
            normalSemanticUI="true"
            id={mobileOrNot ? 'quick-view-profile-menu-mobile' : 'quick-view-profile-menu'}
          />
        </div>
      </div>
    );
  };
  let aboutMenuHeightClass = calculateMenuHeight();
  let isSingleColumn = !props.userHasWaitingAreas || !props.userHasMeetingRooms;
  return (
    <div>
      <Container fluid as={Media} at="mobile">
        <Modal
          onClose={props.onClose}
          show={props.showQuickViewModal && !props.isAnyOtherOverlayFormVisible}
          isNonTransparentBgModal={true}
          className="quick-view-modal bg-transparent single-column-quick-view scrolling"
        >
          {generateHeaderMarkup(true, aboutMenuHeightClass)}
          <CenterPanel
            loggedInUserHandler={props.loggedInUserHandler}
            isSingleColumn={isSingleColumn}
            userHasWaitingAreas={props.userHasWaitingAreas}
            userHasMeetingRooms={props.userHasMeetingRooms}
            canSeeEntityAdminPage={props.canSeeEntityAdminPage}
            userHasReports={props.userHasReports}
            userHasAdminRights={props.userHasAdminRights}
            canAccessResourceCentre={props.canAccessResourceCentre}
            dispatch={props.dispatch}
            waitingAreas={props.waitingAreas}
            isMobileView={true}
          />
        </Modal>
      </Container>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <Modal
          onClose={props.onClose}
          isNonTransparentBgModal={true}
          show={props.showQuickViewModal && !props.isAnyOtherOverlayFormVisible}
          className={
            'quick-view-modal bg-transparent' +
            (isSingleColumn ? ' single-column-quick-view scrolling' : ' multi-column-quick-view')
          }
        >
          {generateHeaderMarkup(false, aboutMenuHeightClass)}
          <CenterPanel
            loggedInUserHandler={props.loggedInUserHandler}
            isSingleColumn={isSingleColumn}
            userHasWaitingAreas={props.userHasWaitingAreas}
            userHasMeetingRooms={props.userHasMeetingRooms}
            canSeeEntityAdminPage={props.canSeeEntityAdminPage}
            userHasReports={props.userHasReports}
            userHasAdminRights={props.userHasAdminRights}
            canAccessResourceCentre={props.canAccessResourceCentre}
            dispatch={props.dispatch}
            waitingAreas={props.waitingAreas}
            isMobileView={false}
          />
        </Modal>
      </Container>
    </div>
  );
};

export default ViewQuickView;
